import Script from "next/script";
import { config } from "@jetblue/dotcom-config/dotcom";
import { TrustArcClient } from "./client";

export {
  required,
  functional,
  advertising,
  type ConsentLevel,
} from "./observer";

const TRUST_ARC_CONSENT_BLACKBAR_ELEMENT_ID = "consent_blackbar";

export const TrustArc = async () => {
  const { TRUST_ARC_URL } = await config();
  if (!TRUST_ARC_URL) {
    return null;
  }

  let trustArcOrigin: string;
  try {
    trustArcOrigin = new URL(TRUST_ARC_URL).origin;
  } catch {
    return null;
  }

  return (
    <>
      <TrustArcClient trustArcOrigin={trustArcOrigin} />
      <Script src={TRUST_ARC_URL} />
      <div id={TRUST_ARC_CONSENT_BLACKBAR_ELEMENT_ID} />
    </>
  );
};
